import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 6C8.69 6 6 8.69 6 12C6 15.31 8.69 18 12 18C15.31 18 18 15.31 18 12C18 8.69 15.31 6 12 6ZM12 16.43C9.55 16.43 7.57 14.44 7.57 12C7.57 9.56 9.55 7.57 12 7.57C14.45 7.57 16.44 9.56 16.44 12C16.44 14.44 14.45 16.43 12 16.43ZM15.45 10.52L11.13 14.8L8.59 12.58L9.62 11.4L11.06 12.66L14.35 9.4L15.45 10.51V10.52Z" fill={ fill || 'currentColor' } />
    </svg>
);
